module.exports = __webpack_public_path__ + "static/img/Pedro.1aa89e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Pedro.jpg
// module id = ksHW
// module chunks = 1